import { ref } from "vue";

export type ActivityKind =
  | "item"
  | "xp"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "combat-good"
  | "combat-bad";

export type ActivityEntry = {
  id: number;
  at: number;
  kind: ActivityKind;
  message: string;
};

const entries = ref<ActivityEntry[]>([]);
let nextId = 1;
const MAX_ENTRIES = 250;

export function useActivityLog() {
  function add(kind: ActivityKind, message: string) {
    entries.value.unshift({ id: nextId++, at: Date.now(), kind, message });
    if (entries.value.length > MAX_ENTRIES) entries.value.splice(MAX_ENTRIES);
  }

  function clear() {
    entries.value = [];
  }

  return { entries, add, clear };
}

